import { useCallback, useEffect, useState } from "react";
import "./App.css";
import "./screens.css";
import SignIn from "./components/SignIn";
import { Shell, NAV } from "./components/Shell";
import MyDay from "./screens/MyDay";
import Floor from "./screens/Floor";
import Clients from "./screens/ClientsHours";
import Export from "./screens/ExportHours";
import Team from "./screens/Team";
import { api, restore, setToken } from "./lib/api";
import { syncClock } from "./lib/time";
import { applyTheme, readTheme } from "./lib/theme";

applyTheme(readTheme());

function Soon({ name }) {
  return <div className="empty" data-testid={`soon-${name}`}>{name} arrives in the next step.</div>;
}

function Home({ me, setMe, onSignOut }) {
  const first = NAV.find((n) => n.show(me.caps)).id;
  const [route, setRoute] = useState(first);
  const refreshMe = useCallback(async () => {
    const r = await api("/me");
    if (r.ok) { syncClock(r.data.serverNow); setMe(r.data); }
  }, [setMe]);
  const screens = {
    myday: <MyDay me={me} refreshMe={refreshMe} />,
    floor: <Floor me={me} mode="floor" key="floor" refreshMe={refreshMe} />,
    plan: <Floor me={me} mode="plan" key="plan" refreshMe={refreshMe} />,
    clients: <Clients me={me} go={setRoute} />,
    export: <Export me={me} />,
    team: <Team me={me} />,
  };
  return (
    <Shell me={me} route={route} setRoute={setRoute} onSignOut={onSignOut}>
      {screens[route] || <Soon name={NAV.find((n) => n.id === route).label} />}
    </Shell>
  );
}

export default function App() {
  const [me, setMe] = useState(undefined);
  useEffect(() => { restore().then((m) => { if (m) syncClock(m.serverNow); setMe(m || null); }); }, []);
  async function signOut() {
    await api("/auth/logout", { method: "POST", auth: false });
    setToken(null);
    setMe(null);
  }
  if (me === undefined) return <div className="boot" data-testid="boot-loading">CK Tiffin</div>;
  return me ? <Home me={me} setMe={setMe} onSignOut={signOut} /> : <SignIn onSignedIn={setMe} />;
}
